import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RegisterService } from '../shared/services/register.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../shared/services/loader.service';
import { finalize } from 'rxjs/operators';
import { WizardComponent } from 'angular-archwizard';
import { SelectOption } from '../shared/entities/select-option';
import { Router } from '@angular/router';
import { EnrollCompany, InstallationTypeEnum } from '../shared/entities/enroll-company';

@Component({
  selector: 'app-client-register',
  templateUrl: './client-register.component.html',
  styleUrls: ['./client-register.component.scss']
})
export class ClientRegisterComponent implements OnInit {

  @ViewChild('wizard', { static: false}) wizard: WizardComponent;

  public htmlForm: FormGroup;
  public fb: FormBuilder = new FormBuilder;
  public isFinished: boolean = false;
  public isUniqueCodeValidated: boolean = false;
  public isPhoneNumberValidated: boolean = false;
  public showValidation: boolean = false;

  public frontOfficeApiKey: string;
  public backOfficeApiKey: string;
  public downloadUrl: string;
  public downloadTrainingUrl: string;

  public frontOfficeVideoUrl = 'https://freyapos.ro/np/wp-content/uploads/2024/05/Prezentare-Freya-Shop-FrontOffice.mp4';
  public backOfficeVideoUrl = 'https://freyapos.ro/np/wp-content/uploads/2024/05/Prezentare-Freya-Shop-BackOffice.mp4';


  public listOfInstallationTypes: Array<SelectOption>;


  isLoading$ = this.loaderService.loadingProgress;

  constructor(public registerService: RegisterService,
          public toasterService: ToastrService,
          public loaderService: LoaderService,
          public router: Router) { }


  
  ngOnInit(): void {
    this.createForm();

    this.listOfInstallationTypes = [
      new SelectOption(InstallationTypeEnum.Self.toString(), 'Cont propriu'),
      new SelectOption(InstallationTypeEnum.Remote.toString(), 'Remote'),
      new SelectOption(InstallationTypeEnum.Office.toString(), 'Instalare la Sediu')
    ];
  }

  public createForm() {
    this.htmlForm = this.fb.group({
      firstName: [null, Validators.required],
      lastName: [null, Validators.required],
      name: [null, Validators.required],
      uniqueCode : [null, Validators.required],
      identificationCode : [null, Validators.required],
      address : [null, Validators.required],
      city : [null, Validators.required],
      email : [null, Validators.required],
      phone : [null, Validators.required],
      termsAndConditions: [null],
      verificationCode: [null],
      verificationCodeUid: [null],
    });
  }

  public popErrorToaster(message: string) {
    this.toasterService.error('', message);
  }

  public popSuccessToaster(message: string) {
    this.toasterService.success('', message);
  }


  public btnNextClick(){
    if(this.wizard.currentStepIndex === 0){
      if(this.htmlForm.get('firstName').errors || this.htmlForm.get('lastName').errors || this.htmlForm.get('email').errors || this.htmlForm.get('phone').errors){
        let errorMessage = 'Campurile sunt obligatorii : ';
        if(this.htmlForm.get('firstName').errors)
          errorMessage = errorMessage + 'Prenume; ';
        if(this.htmlForm.get('lastName').errors)
          errorMessage = errorMessage + 'Nume; ';
        if(this.htmlForm.get('email').errors)
          errorMessage = errorMessage + 'Email; ';
        if(this.htmlForm.get('phone').errors)
          errorMessage = errorMessage + 'Telefon; ';
        this.popErrorToaster(errorMessage);
        return;
      }

      this.loaderService.showLoader();
      this.registerService.SendSMSCode(this.htmlForm.value.phone)
      .pipe(finalize(() => this.loaderService.hideLoader()))
      .subscribe(
        (result) => {
          this.showValidation = true;

          this.htmlForm.patchValue({
            verificationCodeUid: result.payload.uid
          });
        }
      );
    }

    if(this.wizard.currentStepIndex === 1){
      if(this.htmlForm.get('name').errors || this.htmlForm.get('uniqueCode').errors || this.htmlForm.get('identificationCode').errors || this.htmlForm.get('city').errors || this.htmlForm.get('address').errors){
        let errorMessage = 'Campurile sunt obligatorii : ';
        if(this.htmlForm.get('name').errors)
          errorMessage = errorMessage + 'Nume Companie; ';
        if(this.htmlForm.get('uniqueCode').errors)
          errorMessage = errorMessage + 'Cod unic; ';
        if(this.htmlForm.get('identificationCode').errors)
          errorMessage = errorMessage + 'Cod de identificare; ';
        if(this.htmlForm.get('city').errors)
          errorMessage = errorMessage + 'Oras; ';
        if(this.htmlForm.get('address').errors)
          errorMessage = errorMessage + 'Adresa; ';
        this.popErrorToaster(errorMessage);
        return;
      }
      this.wizard.goToNextStep();
    }
  }

  public btnPreviousClick(){
    this.isPhoneNumberValidated = false;
    this.wizard.goToPreviousStep();
  }

  public btnHideCompanyDetails(){
    this.isUniqueCodeValidated = false;
  }

  public btnHideValidation(){
    this.showValidation = false;
  }

  public validateUniqueCode(){
    this.htmlForm.patchValue({
      name: null,
      identificationCode : null,
      address : null,
      city : null,
    });

    this.loaderService.showLoader();
    this.registerService.checkCompanyUniqueCode(this.htmlForm.value.uniqueCode)
    .pipe(finalize(() => this.loaderService.hideLoader()))
    .subscribe(
      (result) => {
        if(result.isSuccess === true)
        {
          this.popSuccessToaster("Cod unic validat cu succes!");
          this.isUniqueCodeValidated = true;
          this.htmlForm.patchValue({
            name: result.payload.name.trim(),
            identificationCode: result.payload.identificationCode,
            city: result.payload.city,
            address: result.payload.fullAddress,
          });
        }
      }
    );

    this.isUniqueCodeValidated = true;
  }

  public validateSMSCode(){
    this.loaderService.showLoader();
    this.registerService.validateSMSCode(this.htmlForm.value.verificationCodeUid, this.htmlForm.value.verificationCode)
    .pipe(finalize(() => this.loaderService.hideLoader()))
    .subscribe(
      (result) => {
        if(result.isSuccess === true)
        {
          this.popSuccessToaster("Codul a fost validat cu succes!");
          this.showValidation = false;
          this.wizard.goToNextStep();
          this.htmlForm.patchValue({
            verificationCode: null,
            verificationCodeUid: null,
          });
          this.isUniqueCodeValidated = false;
        }
      }
    );
  }

  public checkUserPageValidity()
  {
    if (this.htmlForm.get('firstName').valid && this.htmlForm.get('lastName').valid && this.htmlForm.get('email').valid && this.htmlForm.get('phone').valid ) {
      return false;
    }
    return true;
  }

  public checkCompanyPageValidity()
  {
    if (this.htmlForm.get('name').valid && this.htmlForm.get('uniqueCode').valid && this.htmlForm.get('identificationCode').valid && this.htmlForm.get('city').valid && this.htmlForm.get('address').valid) {
      return false;
    }
    return true;
  }


  public btnFinalizaClick(){
    if(this.htmlForm.invalid){
      let errorMessage = 'Completati toate campurile necesare';
      this.popErrorToaster(errorMessage);
      return;
    }

    this.insertCompany();
  }

  public insertCompany(){
    let company: EnrollCompany = new EnrollCompany();

    company = this.prepareEntityForSave();

    this.loaderService.showLoader();
    this.registerService.enrollCompany(company)
    .pipe(finalize(() => this.loaderService.hideLoader()))
    .subscribe(
      (result) => {
        if(result.isSuccess === true)
        {
          this.isFinished = true;
          this.frontOfficeApiKey = result.payload.frontOfficeApiKey;
          this.backOfficeApiKey = result.payload.backOfficeApiKey;
          this.downloadUrl = result.payload.downloadUrl;
          this.downloadTrainingUrl = result.payload.downloadTrainingUrl;
          this.popSuccessToaster("Inrolarea a fost realizata cu succes!")
        }
      }
    );
  }

  public prepareEntityForSave(): EnrollCompany {
    const companyFormValue = this.htmlForm.value;
    const company: EnrollCompany = new EnrollCompany();
    company.name = companyFormValue.name;
    company.firstName = companyFormValue.firstName;
    company.lastName = companyFormValue.lastName;
    company.uniqueCode = companyFormValue.uniqueCode;
    company.identificationCode = companyFormValue.identificationCode;
    company.address = companyFormValue.address;
    company.city = companyFormValue.city;
    company.email = companyFormValue.email;
    company.phone = companyFormValue.phone;

    return company;
  }


  public btnFinish(){
    this.isFinished = false;
    this.isUniqueCodeValidated = false;
    this.isPhoneNumberValidated = false;
    this.htmlForm.reset();
  }


}
